import * as DateFns from 'date-fns';

export default function formatter(input: {
  value: string;
  format?: string;
  // If passed and type === date, this will be used instead of format on mobile
  mobileDateFormat?: string;
  type?: 'date' | 'number' | 'text' | 'card' | 'bankaccount' | 'phone';
  credit?: boolean;
  inputFormat?: string;
  delimiter?: string;
  delimitedAt?: number;
  windowWidth?: number;
}): string {
  const {
    type = 'date',
    inputFormat = 'MM/dd/yyyy',
    format = 'MM/dd/yyyy',
    delimiter = ',',
    delimitedAt = 1
  } = input;

  const camelize = (string: string) =>
    string.replace(/-([a-z])/gi, (s, group) => group.toUpperCase());

  if (input.value) {
    try {
      if (type === 'date') {
        let date;
        if (inputFormat !== 'iso') {
          date = DateFns.parse(input.value, inputFormat, new Date());
        } else {
          date = new Date(input.value);
        }
        return DateFns.format(
          date,
          input.mobileDateFormat &&
            !!input.windowWidth &&
            input.windowWidth < 992
            ? input.mobileDateFormat
            : format
        );
      }
      if (type === 'number' && format === 'amount') {
        const currencyValue: number = input.credit
          ? Number(input.value) * -1
          : Number(input.value);
        if (currencyValue < 0) {
          return `-$${(currencyValue * -1).toFixed(2)}`;
        }
        return `$${currencyValue.toFixed(2)}`;
      }
      if (type === 'text') {
        switch (format) {
          case 'lowercase':
            return input.value.trim().toLowerCase();
          case 'uppercase':
            return input.value.trim().toUpperCase();
          case 'camelize':
            return camelize(input.value.trim());
          case 'capitalize':
            return input.value
              .trim()
              .toLowerCase()
              .replace(/\b[a-zA-Z]/g, match => match.toUpperCase());
          case 'delimited':
            return input.value
              .trim()
              .replace(
                new RegExp(`\\d{${delimitedAt}}(?=.)`, 'g'),
                `$&${delimiter}`
              );
          case 'masked':
            return input.value.trim().replace(new RegExp(`.`, 'g'), `\u2022`);
          case 'phone':
            return (
              `${input.value}`.replace(/\D/g, '') &&
              input.value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
            );
          default:
            return input.value;
        }
      }
      if (type === 'card') {
        const last4 = input.value.trim().slice(-4);
        if (format.trim().toUpperCase() === 'AMEX') {
          return `${'0000'.replace(
            new RegExp(`.`, 'g'),
            `\u2022`
          )} ${'000000'.replace(new RegExp(`.`, 'g'), `\u2022`)} ${'0'.replace(
            new RegExp(`.`, 'g'),
            `\u2022`
          )}${last4}`;
        }
        return `${'0000'.replace(
          new RegExp(`.`, 'g'),
          `\u2022`
        )} ${'0000'.replace(new RegExp(`.`, 'g'), `\u2022`)} ${'0000'.replace(
          new RegExp(`.`, 'g'),
          `\u2022`
        )} ${last4}`;
      }
      if (type === 'bankaccount') {
        const last4 = input.value.trim().slice(-4);
        const remainingPart = input.value.trim().slice(0, -4);
        return `${remainingPart.replace(
          new RegExp(`.`, 'g'),
          `\u2022`
        )}${last4}`;
      }
      if (type === 'phone') {
        if (format === 'tel') {
          return `${input.value.match(
            /((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}/g
          ) || input.value}`;
        }
        let fPh = '';
        for (let i = 0; i < input.value.length; i++) {
          if (i === 0) {
            fPh += '(';
          }
          if (i === 3) {
            fPh += ') ';
          }
          if (i === 6) {
            fPh += '-';
          }
          fPh += input.value.charAt(i);
        }
        return fPh;
      }
      return input.value;
    } catch (e) {
      return input.value;
    }
  } else {
    return '';
  }
}
